import React from "react";
import { connect } from "react-redux";
import { Dispatch, AnyAction } from 'redux';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { defaultWebchatOptions, IAppState, WebchatOptions } from "../../Redux/reduxState";
import { actionTypes, genericSingleAction } from "../../Redux/actions";
import { themes, ThemeDefinition } from "../constants/themes";

declare const DruidWebchat_v2: any;

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 300 } };

interface OwnProps {
    id: string;
    value?: any;
    onChange: (styleElementName: string, value: any) => void;
}

interface DispatchProps {
    setWebchatOptions: (options: WebchatOptions) => void;
}

type PropsType = OwnProps & DispatchProps;

export class ThemeSelector extends React.Component<PropsType> {
    private applyTheme = (theme: ThemeDefinition) => {
        const merged: WebchatOptions = defaultWebchatOptions(theme.options);
        this.props.setWebchatOptions(merged);
        this.props.onChange(this.props.id, theme.id);

        const druidWebChatDispatch = DruidWebchat_v2?.druidWebChatInstance?.druidWebChatDispatch;
        if (druidWebChatDispatch) {
            druidWebChatDispatch({ type: 'SET_MERGEDCHATOPTIONS', payload: merged });
        }
    };

    private onChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
        const theme = option && themes.find(t => t.id === option.key);
        if (theme) {
            this.applyTheme(theme);
        }
    };

    render() {
        if (!themes.length) {
            return <div><strong>No themes are currently available.</strong></div>;
        }

        return (
            <>
                <p>Selecting a theme immediately replaces all current webchat style customizations with that theme's predefined values.</p>
                <Dropdown
                    placeholder="Select a theme..."
                    selectedKey={this.props.value ?? null}
                    options={themes.map(t => ({ key: t.id, text: t.displayName }))}
                    styles={dropdownStyles}
                    onChange={this.onChange}
                />
            </>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchProps => ({
    setWebchatOptions: (options: WebchatOptions) => {
        dispatch(genericSingleAction<any>(actionTypes.UPDATE_ROOT_WEBCHAT_STATE_VARIABlE, { propertyName: 'webchatOptions', value: options }));
    }
});

export default connect(
    null,
    mapDispatchToProps
)(ThemeSelector);